// extracted by mini-css-extract-plugin
export default {"yelpOverflow":"yelpOverflow--LyuKq"};